import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';

import Tooltip from 'dashboard/components/Tooltip';
import { Label, Paragraph } from 'design-system/components/Text';
import { Iso8601DateString } from 'lib/types';

const RecencyLabel = ({
  queriedAt,
  recencyIso,
}: {
  queriedAt: Iso8601DateString;
  recencyIso?: string;
}) => {
  const [relativeText, setRelativeText] = useState('just now');

  // Refresh the relative time every minute
  useEffect(() => {
    const intervalId = setInterval(() => {
      // When we've just ran this, don't show '0 seconds ago' say, 'just now'
      DateTime.fromISO(queriedAt).toRelative()?.includes('seconds ago')
        ? setRelativeText('just now')
        : setRelativeText(DateTime.fromISO(queriedAt).toRelative() as string);
    }, 60000);
    return () => {
      clearInterval(intervalId);
    };
  });

  return (
    <Tooltip
      disabled={recencyIso == null}
      placement='top'
      trigger='hover'
      tooltip={
        recencyIso ? (
          <Paragraph>
            Data is up to date as of {DateTime.fromISO(recencyIso).toRelative()}
          </Paragraph>
        ) : null
      }
      hideArrow={true}
    >
      {relativeText && (
        <Label size='md' color='tertiary' weight='bold'>
          Last ran {relativeText}
        </Label>
      )}
    </Tooltip>
  );
};

export default RecencyLabel;
